import { useStyletron } from '@thanx/uikit/theme'
import Campaigns from 'components/Navbar/Campaigns'
import { getExperiencesPaths, paths } from 'components/Navbar/constants'
import Customers from 'components/Navbar/Customers'
import Experiences from 'components/Navbar/Experiences'
import Feedback from 'components/Navbar/Feedback'
import Left from 'components/Navbar/Left'
import Loyalty from 'components/Navbar/Loyalty'
import OperationsCenter from 'components/Navbar/OperationsCenter'
import ProfileMenu from 'components/Navbar/ProfileMenu'
import Rewards from 'components/Navbar/Rewards'
import Settings from 'components/Navbar/Settings'
import useFlag from 'hooks/useFlag'
import React from 'react'
import Navbar from 'react-bootstrap-five/Navbar'
import { merchantTheme } from 'theme'
import { useIsMobile } from 'utilities/responsive'
import Help from './Help'
import HomeLogo from './HomeLogo'
import LaunchNotes from './LaunchNotes'
import Status from './Status'

const Bar: React.FC = () => {
  const [css] = useStyletron()
  const isMobile = useIsMobile()
  const settingsPageEnabled = useFlag('mx-unavailable-item-visibility', false)
  const operationsCenterEnabled = useFlag('operations-center', false)
  const experiencesPaths = getExperiencesPaths(operationsCenterEnabled)

  return (
    <Navbar
      variant="dark"
      className={`p-0 align-items-stretch ${css({
        backgroundColor: merchantTheme.colors.grey90,
      })}`}
    >
      {isMobile && <Left />}
      <HomeLogo />
      {!isMobile && (
        <>
          <Campaigns paths={paths.campaigns.paths} />
          <Loyalty paths={paths.loyalty.paths} />
          <Rewards paths={paths.rewards.paths} />
          <Customers paths={paths.customers.paths} />
          {operationsCenterEnabled ? (
            <OperationsCenter paths={paths.operations_center.paths} />
          ) : (
            <Feedback paths={paths.feedback.paths} />
          )}
          <Experiences paths={experiencesPaths} />
          {settingsPageEnabled && <Settings paths={paths.settings.paths} />}
          <div className="justify-content-end flex-grow-1 d-flex">
            <Status />
            <Help />
            <LaunchNotes />
            <ProfileMenu />
          </div>
        </>
      )}
    </Navbar>
  )
}

export default Bar
